import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserContextProvider } from "./ContextAPI/useUserContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import './i18n';

import { Provider } from "react-redux";
import { store } from "./store/store";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <UserContextProvider>
        <GoogleOAuthProvider clientId={googleClientId}>
          <App />
        </GoogleOAuthProvider>
      </UserContextProvider>
    </Provider>
  </BrowserRouter>
);
